import { Tooltip } from '~/components/ui/Tooltip';
import type { UserProfileProps } from '~/lib/types/netlify';
import { Loader2 } from 'lucide-react';

export const UserProfile = ({ user, onDisconnect, isDisconnecting }: UserProfileProps) => {
  return (
    <div className="flex items-center justify-between mb-4 bg-dualite-background-button rounded-md p-2">
      <div className="flex items-center gap-3">
        {user.avatar ? (
          <img
            src={user.avatar}
            alt={user.name || 'User'}
            className="w-6 h-6 rounded-full border border-dualite-border-secondary"
          />
        ) : (
          <div className="w-6 h-6 rounded-full bg-dualite-background-button-hover flex items-center justify-center text-dualite-text-modal-primary text-xs font-medium overflow-hidden border border-dualite-border-primary">
            {user.name?.charAt(0).toUpperCase() || user.email?.split('@')[0].charAt(0).toUpperCase()}
          </div>
        )}
        <div className="flex-1 min-w-0">
          {user.name && (
            <p className="text-sm text-dualite-text-modal-primary font-medium leading-none m-0">{user.name}</p>
          )}
          {user.email && (
            <p className="text-xs text-dualite-text-modal-caption leading-tight m-0 mt-0.5">
              {user.email.length > 35 ? `${user.email.slice(0, 35)}...` : user.email}
            </p>
          )}
        </div>
      </div>
      <Tooltip content="Disconnect">
        <button
          onClick={onDisconnect}
          disabled={isDisconnecting}
          className="p-1.5 text-dualite-text-modal-caption hover:text-dualite-text-modal-primary bg-transparent 
            hover:bg-dualite-background-button-hover rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isDisconnecting ? <Loader2 className="w-4 h-4 animate-spin" /> : <div className="i-ph:sign-out w-4 h-4" />}
        </button>
      </Tooltip>
    </div>
  );
};
